<template>
<div>
    <div v-if="isMutation" class="form-row">
        <div class="col-7">
            <span>Effective On: </span>
            <span>{{ $filters.date(plan.effective_on) }}</span>
        </div>

        <div class="col-5 text-right">
            <a v-if="mode == 'full'" href @click.prevent="mode = 'diff'">Show Changes</a>
            <a v-if="mode == 'diff'" href @click.prevent="mode = 'full'">Show Full Plan Info</a>
        </div>

        <div class="col-12">Created by: {{ plan.created_by ? plan.created_by.email : '--' }}</div>
    </div>

    <div v-else>
        <span>Last Modified Date: </span>
        <span>{{ $filters.date(plan.updated_on) }}</span>
        <div>Created by: {{ plan.created_by ? plan.created_by.email : '--' }}</div>
    </div>

    <div v-if="mode == 'diff'" class="mt-2">
        <h5>Changes</h5>

        <span v-if="isMutation">Reason for Change: </span> <span v-if="isMutation">{{ plan.reason_for_change_pretty }}</span><br />

        <div v-if="diff.tier">
            <span>Tier: </span>
            <span>{{ diff.tier.old }} -&gt; {{ diff.tier.cur }}</span>
        </div>

        <div v-if="diff.employee_monthly_rate">
            <span>Employee Cost: </span>
            <span>{{ $filters.dollars(diff.employee_monthly_rate.old) }} -&gt; {{ $filters.dollars(diff.employee_monthly_rate.cur) }}</span>
        </div>

        <div v-if="diff.employer_monthly_rate">
            <span>Employer Cost: </span>
            <span>{{ $filters.dollars(diff.employer_monthly_rate.old) }} -&gt; {{ $filters.dollars(diff.employer_monthly_rate.cur) }}</span>
        </div>

    </div>

    <div v-if="mode == 'full'" class="mt-2">
        <h5>Plan Info</h5>

        <span v-if="isMutation">Reason for Change: </span> <span v-if="isMutation">{{ plan.reason_for_change_pretty }}</span><br />

        <span>Tier: </span> <span>{{ plan.tier_pretty }}</span><br />

        <span>Employee Cost: </span> <span>{{ $filters.dollars(plan.employee_monthly_rate) }}<span v-if="plan.has_custom_employee_rate" class="text-muted"> (overridden)</span></span><br />
        <span>Employer Cost: </span> <span>{{ $filters.dollars(plan.employer_monthly_rate) }}</span><br />
        <span>Total Cost: </span> <span>{{ $filters.dollars(plan.total_monthly_rate) }}</span><br />
    </div>

</div>
</template>

<script>

export default {
    props: ['isMutation', 'plan', 'diff', ],
    data() {
        return {
            mode: this.isMutation ? 'diff' : 'full',  // Can be diff or full
        }
    },
}
</script>
